import { getRequest, postRequest, deleteRequest } from "../helpers/fetchHandler"
import {
  CAMPAIGNS_LOADING,
  CAMPAIGNS_SUCCESS,
  CAMPAIGNS_FAILED,
  CREATE_CAMPAIGN_LOADING,
  CREATE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_FAILED,
  DELETE_CAMPAIGN_LOADING,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_FAILED,
} from "../constants/actionTypes"

export function fetchCampaigns(activityId) {
  return async dispatch => {
    dispatch({ type: CAMPAIGNS_LOADING })

    const url = `/api/v1/campaigns/activity/${activityId}`
    try {
      const response = await getRequest({ url, auth: true })
      dispatch({ type: CAMPAIGNS_SUCCESS, payload: response, meta: { activityId } })
      return response
    } catch (error) {
      dispatch({ type: CAMPAIGNS_FAILED, error })
      throw error
    }
  }
}

export function createCampaign(data) {
  return async dispatch => {
    dispatch({ type: CREATE_CAMPAIGN_LOADING })

    const url = `/api/v1/campaigns`
    try {
      const response = await postRequest({ url, data, auth: true })
      dispatch({ type: CREATE_CAMPAIGN_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: CREATE_CAMPAIGN_FAILED, error })
      throw error
    }
  }
}

export function deleteCampaign(id) {
  return async dispatch => {
    dispatch({ type: DELETE_CAMPAIGN_LOADING })

    const url = `/api/v1/campaigns/${id}`
    try {
      await deleteRequest({ url, auth: true })
      dispatch({ type: DELETE_CAMPAIGN_SUCCESS, payload: id })
      return Promise.resolve()
    } catch (error) {
      dispatch({ type: DELETE_CAMPAIGN_FAILED, error })
      throw error
    }
  }
}
